"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemPipes = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _paulCorePackage = require("paul-core-package");
var _models = require("../../models");
var _constants = require("../../../utils/constants");
var _CubeModel = _interopRequireDefault(require("../Models/CubeModel"));
var _Types = require("../../../Types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  ComponentTypes
} = _paulCorePackage.constants;
const pipes = [{
  id: 1,
  highlightsType: _constants.pipesTypes.heatingReturn,
  positionY: _constants.verticalPipeSpacing
}, {
  id: 2,
  highlightsType: _constants.pipesTypes.heatingFlow,
  positionY: 2 * _constants.verticalPipeSpacing
}];
const ItemPipes = exports.ItemPipes = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    position = [0, 0, 0],
    isSplitPipes = false
  } = _ref;
  const getPositionOnPipe = function getPositionOnPipe() {
    let i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    const pipeLength = 6;
    /** position centering by function: i * s/n + s/2n
     * , where i - index, s - pipe length, n - count of pipes */
    return i * pipeLength / pipes.length + pipeLength / (2 * pipes.length);
  };
  const startConnectPipes = 3;
  return /*#__PURE__*/_react.default.createElement("group", {
    dispose: null,
    position: position
  }, pipes.map((pipe, index) => /*#__PURE__*/_react.default.createElement("group", {
    key: pipe.id,
    position: [0, pipe.positionY, 0]
  }, /*#__PURE__*/_react.default.createElement("group", null, /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 0, 0],
    args: [1, 1, 0.5],
    highlightsType: pipe.highlightsType
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 0, -0.25],
    scale: [1, 1, _constants.sizeOfStraightPipePerUnit * _constants.ModelWidth[ComponentTypes.HtgHx]],
    rotation: [0, 0, 0],
    highlightsType: pipe.highlightsType
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 0, -_constants.ModelWidth[ComponentTypes.HtgHx] + 0.5],
    args: [1, 1, 0.5],
    highlightsType: pipe.highlightsType
  })), isSplitPipes && /*#__PURE__*/_react.default.createElement("group", {
    position: [-_constants.spaseBetweenPipesByColInEquipmentItem, 0, 0]
  }, /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 0, 0],
    args: [1, 1, 0.5],
    highlightsType: pipe.highlightsType
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 0, -0.25],
    scale: [1, 1, _constants.sizeOfStraightPipePerUnit * (_constants.ModelWidth[ComponentTypes.HtgHx] - _constants.widthColConnectionInEquipmentItem - getPositionOnPipe(index) + startConnectPipes)],
    rotation: [0, 0, 0],
    highlightsType: pipe.highlightsType
  }), /*#__PURE__*/_react.default.createElement(_models.TubeCurve1mModel, {
    position: [0, 0, -_constants.ModelWidth[ComponentTypes.HtgHx] + _constants.widthColConnectionInEquipmentItem + 0.8 + getPositionOnPipe(index) - startConnectPipes],
    rotation: [Math.PI, Math.PI, 0],
    highlightsType: pipe.highlightsType
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [1.1, 0, -_constants.ModelWidth[ComponentTypes.HtgHx] + _constants.widthColConnectionInEquipmentItem - 0.2 + getPositionOnPipe(index) - startConnectPipes],
    scale: [1, 1, _constants.sizeOfStraightPipePerUnit * (_constants.spaseBetweenPipesByColInEquipmentItem - 0.62)],
    rotation: [0, -Math.PI / 2, 0],
    highlightsType: pipe.highlightsType
  })))));
}, (prev, next) => prev.position === next.position && prev.isSplitPipes === next.isSplitPipes);
ItemPipes.propTypes = {
  position: _Types.VectorType,
  isSplitPipes: _propTypes.default.bool
};
ItemPipes.defaultProp = {
  position: [0, 0, 0],
  isSplitPipes: false
};